import { DataGrid } from "@mui/x-data-grid";

const BaseDataTableV2 = ({
  columns = [],
  data = [],
  isLoading = true,
  className,
  columnHeaderHeight = 38,
  hideFooter = true,
  pageSizeOptions,
  footer: FooterComponent,
  ...props
}) => {
  return (
    <DataGrid
      {...props}
      className={`border-0 ${className}`}
      rows={data}
      columnHeaderHeight={columnHeaderHeight}
      columns={columns}
      loading={isLoading}
      disableColumnSorting={props.disableColumnSorting ?? true}
      disableColumnMenu
      disableRowSelectionOnClick
      isCellEditable={(params) => false}
      hideFooter={hideFooter}
      pageSizeOptions={pageSizeOptions}
      slots={{
        footer: FooterComponent ? () => <FooterComponent /> : undefined,
      }}
      slotProps={{
        baseCheckbox: {
          sx: {
            color: "#b5b6b7",
            "& .MuiSvgIcon-root": {
              fontSize: "1.2rem",
            },
          },
        },
        pagination: {
          SelectProps: {
            MenuProps: {
              PaperProps: {
                sx: {
                  "& li.MuiMenuItem-root": {
                    color: "#70757cff",
                  },
                },
              },
            },
          },
        },
      }}
      sx={{
        ...props.sx,
        "& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer": {
          opacity: 0,
          transition: "opacity 0.2s",
        },
        "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-iconButtonContainer": {
          opacity: 1,
        },
        "& .MuiDataGrid-row:nth-of-type(even)": {
          backgroundColor: "white",
        },
        "& .MuiDataGrid-row:hover": {
          backgroundColor: "#f1f1f1",
        },
        "& .css-mmygx2-MuiSelect-select-MuiInputBase-input.css-mmygx2-MuiSelect-select-MuiInputBase-input.css-mmygx2-MuiSelect-select-MuiInputBase-input":
          {
            paddingRight: "24px !important",
          },
        "& .MuiDataGrid-cell": {
          lineHeight: 2,
          display: "flex",
          alignItems: "center",
        },
        "&:last-child td, &:last-child th": { border: 0 },
        "& .MuiTablePagination-spacer": {
          display: "none",
        },
        ".MuiTablePagination-actions": {
          display: "flex",
          justifyContent: "end",
          flex: 1,
          marginLeft: 0,
        },
        "& .MuiDataGrid-row.header-row": {
          backgroundColor: "#EFF4FF !important",
          fontWeight: 600,
          color: "#2E5AAC",
        },
        "& .MuiDataGrid-row.header-row .MuiDataGrid-cellCheckbox, \
        & .MuiDataGrid-row.empty-row .MuiDataGrid-cellCheckbox": {
          display: "none !important",
        },
      }}
    />
  );
};

export default BaseDataTableV2;
